

export const fetchLocalConfig = async (namespaceProductPath: string) => {
    return new Promise(async (resolve, reject) => {
        try {
            console.log(`=== ō͡≡o˞̶ LOADING LOCAL config from local path: ${namespaceProductPath} `);
            const configJson = await fetch(namespaceProductPath)
                .then((res) => {
                    return res.text()
                })
                .then((text) => {
                    let jsonData = {"data": []}
                    try {
                        jsonData = JSON.parse(text)
                        console.log(`LOCAL config file ${namespaceProductPath} loaded successfully`)
                    } catch(err: any) {
                        console.log(`JSON parse error LOCAL config file ${namespaceProductPath} loaded successfully`, err)
                        return jsonData
                    }

                    return jsonData
                }).catch((err) => {
                    reject(err)
                    console.log("ERROR: failed to fetch or parse requested namespace path", namespaceProductPath, err)
                    return {"data": []}
                })
            console.log(`=== ō͡≡o˞̶ LOADED config from local path: ${namespaceProductPath} `);
            resolve(configJson)
        } catch (err) {
            console.log("ERROR: failed to fetch requested namespace path", namespaceProductPath, err)
            reject(err)
        }
    })
}